import { render } from "./Notificacao.vue?vue&type=template&id=954ce47a"
import script from "./Notificacao.vue?vue&type=script&lang=ts"
export * from "./Notificacao.vue?vue&type=script&lang=ts"
script.render = render

export default script